<template>
  <Legacy
    view="invoicing"
    action="reconciliation"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Reconciliation',
      breadcrumb: {
        name: 'Reconciliation',
        route: { name: 'billing-reconciliation' }
      }
    }
  }
}
</script>
